import { Button, Select } from '@/components';
import Language from '@/entities/Language';
import { useState } from 'react';
import styles from './DefineMainLanguage.module.css';

interface DefineMainLanguageProps {
  currentMainLanguage: Language | undefined;
  languages: Language[];
  mainLanguageSelected: (language: Language) => void;
}

const DefineMainLanguage = ({
  currentMainLanguage = undefined,
  languages = [],
  mainLanguageSelected = () => {},
}: DefineMainLanguageProps): JSX.Element => {
  const [selectedLanguage, setSelectedLanguage] = useState<
    Language | undefined
  >(undefined);
  return (
    <div className={styles.container}>
      <Select
        options={languages}
        initialOption={currentMainLanguage}
        getOptionKey={(language) => language.code}
        getOptionLabel={(language) => `${language.name} (${language.code})`}
        onChange={setSelectedLanguage}
        placeholder="Choose a language"
      />
      <Button
        label="Set as main language"
        onClick={() => {
          if (selectedLanguage) {
            mainLanguageSelected(selectedLanguage);
          }
        }}
      />
    </div>
  );
};

export default DefineMainLanguage;
